import { useIsMobile, useWindowScroll } from "@core/shared/hooks";
import { isImmersiveChallengeRoute } from "@core/shared/utils/immersive-routes";
import { useLocation } from "@remix-run/react";
import { HeaderDesktop, HeaderMobile, NavbarDrawer } from "./components";

export function Header() {
  const isScrolled = useWindowScroll(100);
  const location = useLocation();
  const isMobile = useIsMobile();

  if (location.search.includes("noLayout")) {
    return null;
  }

  if (isImmersiveChallengeRoute(location.pathname)) {
    return null;
  }

  return (
    <>
      {isMobile ? (
        <HeaderMobile isScrolled={isScrolled} />
      ) : (
        <HeaderDesktop isScrolled={isScrolled} />
      )}
      <NavbarDrawer />
    </>
  );
}
